<template>
  <div class="page">
    <div class="site-logo">
      <img src="../assets/images/extra-logo.png" />
    </div>
    <div class="input-row">
      <div class="icon-input icon-user">
        <img src="../assets/images/account.png" />
      </div>
      <van-field
        v-model="user.loginAccount"
        center
        clearable
        placeholder="请输入账号"
        @blur="viewDefault"
      />
    </div>
    <div class="input-row">
      <div class="icon-input icon-password">
        <img src="../assets/images/password.png" />
      </div>
      <van-field
        v-model="user.password"
        type="password"
        center
        clearable
        placeholder="请输入密码"
        @blur="viewDefault"
      />
    </div>
    <div class="auto-login">
      <span @click="ciamLogin()" class="ciam">手机号登录</span>
      <van-checkbox checked-color="#00545e" v-model="isAutoLogin"
        ><span class="color-green">保持登录状态</span></van-checkbox
      >
    </div>
    <div class="button-line">
      <van-button type="primary" size="large" @click="login">登录</van-button>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  name: 'ActivityDragonSign',
  data () {
    return {
      user: {
        loginAccount: '',
        password: ''
      },
      redirectUrl: '',
      isAutoLogin: false
    }
  },
  created () {
    this.redirectUrl = this.$route.params.redirectUrl
      ? this.$route.params.redirectUrl
      : 'questionnaire'
    console.log(this.$route.params)
    this.fromSource = this.$route.params.fromSource
    this.type = this.$route.params.type
  },
  methods: {
    login () {
      if (!this.user.loginAccount) {
        this.$dialog.alert({ message: '请输入账号' })
        return false
      }
      if (!this.user.password) {
        this.$dialog.alert({ message: '请输入密码' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '登录中'
      })
      let isRemember = Number(this.isAutoLogin)
      let password = cryptoUtils.AESEncrypt(this.user.password)
      let loginParam = {
        loginAccount: this.user.loginAccount,
        password: password,
        isRemember
      }
      activityApi
        .ActivityDragonLogin(loginParam)
        .then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            userUtils.setUserLocal(res.data.resultData)
            if (this.fromSource) {
              this.$router.push({ name: this.redirectUrl, query: { type: this.type, fromSource: this.$route.query.fromSource } })
            } else {
              this.$router.replace({ name: this.redirectUrl })
            }
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    ciamLogin () {
      this.$router.push({ name: 'ciamLogin' })
    }
  }
}
</script>

<style lang="less" scoped>
.auto-login{
  margin-top:20px;
  display:flex;
  justify-content:space-around;
  }
  .ciam{
    font-size: 15px;
    color:#00545e!important;
    line-height: 21px;
    text-decoration:underline
  }
  .color-green{
    color:#00545e!important;
    }
.site-logo {
  width: 135px;
  // height: 64px;
  margin: 80px auto 0 auto;
}
.button-line {
  width: 300px;
  margin: auto;
  margin-top: 30px;
  .van-button--large {
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
  }
}
.input-row {
  width: 300px;
  margin: auto;
  margin-top: 20px;
  position: relative;
  .icon-input {
    position: absolute;
    z-index: 10;
    top: 10px;
  }
  .icon-user {
    width: 17px;
    height: 19px;
    left: 20px;
  }
  .icon-password {
    width: 14px;
    height: 19px;
    left: 21px;
  }
  .van-cell {
    height: 40px;
    padding-left: 46px;
    border-radius: 20px;
  }
}
img {
  width: 100%;
  height: 100%;
}
</style>
